import {LIGHT_THEME} from '@apps-common/ui-theme/Themes';
import {alpha, lighten} from '@mui/material';

// ToDo: port this to ui-maps
export const getDefaultFeatureStyle = (color = 'primary') => [
  {
    'stroke-color': LIGHT_THEME.palette[color]?.main ?? color[500],
    'stroke-width': 2,
    'fill-color': LIGHT_THEME.palette[color]?.light
      ? `${LIGHT_THEME.palette[color]?.light}4D`
      : alpha(lighten(color[500], 0.5), 0.3),
  },
];

export const getSelectedStyle = (color = 'primary') => [
  {
    'stroke-color': 'rgba(0,0,0,0)',
    'stroke-width': 4,
    'fill-color': LIGHT_THEME.palette[color]?.light
      ? `${LIGHT_THEME.palette[color]?.light}A6`
      : alpha(lighten(color[500], 0.5), 0.55),
  },
  {
    'stroke-color': LIGHT_THEME.palette[color]?.dark
      ? LIGHT_THEME.palette[color].dark
      : color[500],
    'stroke-width': 4,
  },
];
